import React from "react";
import "../styles/Statistics.css";

const Statistics = ({ stats }) => {
    return (
        <div className="statistics-container">
            <div className="statistics-grid">
                {stats.map((stat) => (
                    <div key={stat.id} className="stat-card">
                        <div className="stat-icon">{stat.icon}</div>
                        <div className="stat-value">{stat.value}</div>
                        <div className="stat-label">{stat.label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Statistics;
